/* Zet op true voor een publieke versie: verbergt de datumtest en de controlepunten. */
const PUBLIC_BUILD = false;

const CDN = "https://cdn.shopify.com/s/files/1/0968/5224/6861/files/";
const SHOP = "https://muskle.com";

const file = (name) => CDN + name;
const product = (handle) => SHOP + "/products/" + handle;
const collection = (handle) => SHOP + "/collections/" + handle;

const WEEKDAYS = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
const MONTHS = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];

const X_SVG = `<svg viewBox="0 0 100 100" aria-hidden="true">
  <path d="M18 18 L82 82 M82 18 L18 82" stroke="#fff" stroke-width="22" stroke-linecap="square"/>
  <path d="M18 18 L82 82 M82 18 L18 82" stroke="#e30613" stroke-width="12" stroke-linecap="square"/>
</svg>`;
const LOCK_SVG = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="1.5" fill="none" stroke="#fff" stroke-width="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="#fff" stroke-width="2"/></svg>`;

const DEALS = [
  {
    day: 1,
    short: "Creatine + Taurine",
    title: "MUSKLE Creatine + Taurine 500g",
    discount: "-20%",
    mock: true,
    blurb: "Geplande dagdeal: MUSKLE Creatine + Taurine 500g met 20% korting. Dit exacte product staat niet in de shop, dus er is nog geen foto en geen winkelknop."
  },
  {
    day: 2,
    short: "Aminozuren",
    title: "Categorie aminozuren",
    discount: "-25%",
    blurb: "De hele categorie aminozuren met 25% korting. Alleen op deze dag, via de categorieknop.",
    href: collection("amino-acids"),
    cta: "Shop de categorie",
    products: [
      ["Scitec EAA + Glutamine", "scitec-eaa-glutamine", "scitec-eaa-glutamine-01.png?v=1789504718"],
      ["Supplement Needs Intra EAA+", "supplement-needs-intra-eaa-810g", "supplement-needs-intra-eaa-plus-01.webp?v=1789501578"],
      ["Applied Nutrition Amino Fuel EAA 390g", "applied-nutrition-amino-fuel-eaa-390g", "applied-nutrition-amino-fuel-eaa-390g-01.png?v=1789502687"],
      ["Fast Forward Nutrition Glutamine 500 g", "fast-forward-nutrition-glutapure", "fast-forward-nutrition-glutamine-smaakloos-500g-01.png?v=1789503232"]
    ]
  },
  {
    day: 3,
    short: "Shaker cadeau",
    title: "Gratis shaker",
    discount: "CADEAU",
    gift: true,
    mock: true,
    condition: "Bij een aankoop vanaf €60",
    blurb: "Gratis shaker ter waarde van €14,90 bij een aankoop vanaf €60. Het cadeau staat nog niet als product in de shop."
  },
  {
    day: 4,
    short: "FFN Mass Gainer",
    title: "Fast Forward Nutrition Mass Pro+ Mass Gainer 3 kg",
    shop: "Planning: FFN Mass Gainer 3kg",
    discount: "-20%",
    blurb: "Mass Pro+ van Fast Forward Nutrition, verpakking van 3 kg. De geplande korting is 20% en geldt alleen op deze dag.",
    href: product("fast-forward-nutrition-mass-gainer-3-kg-masspro"),
    image: file("fast-forward-nutrition-mass-pro-mass-gainer-3kg-01-chocolate-fudge.png?v=1789503340"),
    price: "Huidige winkelprijs vanaf €59,90"
  },
  {
    day: 5,
    short: "Cream of Rice",
    title: "Trained By JP Cream of Rice 2kg",
    shop: "Planning: TBJP Cream of Rice",
    discount: "-20%",
    blurb: "Cream of Rice van Trained By JP, bus van 2 kg. De geplande korting is 20%.",
    href: product("cream-of-rice"),
    image: file("trained-by-jp-cream-of-rice-2kg-01.png?v=1789505226"),
    price: "Huidige winkelprijs vanaf €24,95"
  },
  {
    day: 6,
    short: "PER4M Hydrate",
    title: "Per4m Hydrate",
    shop: "Planning: PER4M Electrolyten. In de shop is dit Per4m Hydrate, een elektrolytenmix.",
    discount: "-25%",
    blurb: "PER4M Hydrate is een drankmix met elektrolyten. De geplande korting is 25%.",
    href: product("per4m-hydrate"),
    image: file("per4m-hydrate-01.jpg?v=1789501532"),
    price: "Huidige winkelprijs vanaf €24,90"
  },
  {
    day: 7,
    short: "Merk MUSKLE",
    title: "Merk MUSKLE",
    discount: "-22%",
    confirm: true,
    blurb: "Het hele merk MUSKLE met 22% korting, zoals in de tabel. Dat percentage staat nog ter bevestiging.",
    href: collection("muskle-brand"),
    cta: "Shop het merk",
    products: [
      ["Creatine Monohydraat Gummies", "creatine-monohydraat-gummies", "muskle-creatine-monohydrate-gummies-01-strawberry.png?v=1789500937"],
      ["MUSKLE Omega 3 + D3 + K2", "muskle-omega-3-vitamin-d3-k2-120-capsules", "muskle-omega-3-vitamin-d3-k2-120-capsules-01.jpg?v=1789505201"],
      ["MUSKLE Shilajit+ Gummies", "shilajit", "muskle-shilajit-gummies-01.png?v=1789505249"],
      ["Muskle Test Male", "muskle-test-male", "muskle-test-male-01.png?v=1789503625"]
    ]
  },
  {
    day: 8,
    short: "BCAA",
    title: "Categorie BCAA",
    discount: "-26%",
    blurb: "BCAA-producten met 26% korting. Alleen op deze dag.",
    href: collection("bcaa-poeder"),
    cta: "Shop de categorie",
    products: [
      ["BiotechUSA BCAA zero", "biotechusa-bcaa-zero", "biotechusa-bcaa-zero-01.png?v=1789502807"],
      ["Scitec BCAA + Glutamine Xpress", "scitec-nutrition-bcaa-glutamine-xpress", "scitec-nutrition-bcaa-glutamine-xpress-01.png?v=1789504742"],
      ["FFN MadMaxx BCAA 500 g", "fast-forward-nutrition-madmaxx-bcaa", "fast-forward-nutrition-madmaxx-bcaa-500g-01-orange.png?v=1789503314"]
    ]
  },
  {
    day: 9,
    short: "FFN Creatine",
    title: "Fast Forward Nutrition Creatine Micronized 300 g",
    shop: "Planning: FFN Creatine 300g",
    discount: "-22%",
    blurb: "Micronized creatine van Fast Forward Nutrition, 300 gram. De geplande korting is 22%.",
    href: product("fast-forward-nutrition-creatine-micronized-3"),
    image: file("fast-forward-nutrition-creatine-micronized-300g-01.png?v=1789503209"),
    price: "Huidige winkelprijs €14,90"
  },
  {
    day: 10,
    short: "5% 51-50",
    title: "5% Nutrition 51-50",
    shop: "Planning: 5% 51/50. De shopnaam is 5% Nutrition 51-50. De producttekst noemt het ook 51/50.",
    discount: "-16%",
    blurb: "Pre-workout van 5% Nutrition, 30 porties. De geplande korting is 16%.",
    href: product("5-nutrition-51-50"),
    image: file("5-percent-nutrition-51-50-01.png?v=1789501716"),
    price: "Huidige winkelprijs €39,90"
  },
  {
    day: 11,
    short: "Handdoek cadeau",
    title: "Gratis handdoek",
    discount: "CADEAU",
    gift: true,
    mock: true,
    condition: "Bij een aankoop vanaf €60",
    blurb: "Gratis handdoek ter waarde van €9,90 bij een aankoop vanaf €60. De handdoek staat nog niet in de shop."
  },
  {
    day: 12,
    short: "FFN Lean Gainer",
    title: "Fast Forward Nutrition Lean Gainer 2 kg",
    shop: "Planning: FFN Lean Gainer",
    discount: "-18%",
    confirm: true,
    blurb: "Lean Gainer van Fast Forward Nutrition, 2 kg. De tabel toont 18% korting. Dat percentage staat nog ter bevestiging.",
    href: product("fast-forward-nutrition-lean-gainer-2-kg"),
    image: file("fast-forward-nutrition-lean-gainer-2kg-01-chocolate-melange.png?v=1789503277"),
    price: "Huidige winkelprijs vanaf €59,90"
  },
  {
    day: 13,
    short: "Biotech ISO",
    title: "BiotechUSA Iso Whey Zero",
    shop: "Planning: Biotech ISO",
    discount: "-13%",
    blurb: "Iso Whey Zero van BiotechUSA. De geplande korting is 13%.",
    href: product("biotechusa-iso-whey-zero-3"),
    image: file("biotechusa-iso-whey-zero-01.png?v=1789501790"),
    price: "Huidige winkelprijs vanaf €32,90"
  },
  {
    day: 14,
    short: "Magnesium",
    title: "Alle magnesium",
    discount: "-18%",
    blurb: "Magnesium uit het assortiment met 18% korting. Alleen op deze dag.",
    href: collection("magnesium"),
    cta: "Shop de categorie",
    products: [
      ["MUSKLE Magnesium 12-in-1", "muskle-magnesium-12-in-1-magnesium-complex-120-capsules", "muskle-magnesium-12-in-1-complex-120-capsules-01.png?v=1789505201"],
      ["Supplement Needs Magnesium Bisglycinate", "supplement-needs-magnesium-bisglycinate-120-caps", "supplement-needs-magnesium-bisglycinate-120-caps-01.webp?v=1789505377"],
      ["FFN Magnesium Bisglycinaat", "fast-forward-nutrition-magnesium-natural-recources-120-caps", "fast-forward-nutrition-magnesium-bisglycinaat-120-caps-01.png?v=1789502459"],
      ["Trained by JP Magnesium", "trained-by-jp-nutrition-magnesium", "trained-by-jp-nutrition-magnesium-120-caps-01.webp?v=1789505009"]
    ]
  },
  {
    day: 15,
    short: "FFN Oatmeal",
    title: "Fast Forward Nutrition Oatmeal 5kg",
    shop: "Planning: FFN Oatmeal 5kg",
    discount: "-20%",
    blurb: "Havermout van Fast Forward Nutrition, zak van 5 kg. De geplande korting is 20%.",
    href: product("fast-forward-nutrition-oatmeal-5-kg"),
    image: file("fast-forward-nutrition-oatmeal-5kg-01.png?v=1789502482"),
    price: "Huidige winkelprijs €29,90"
  },
  {
    day: 16,
    short: "Vetverbranders",
    title: "Categorie vetverbranders",
    discount: "-25%",
    blurb: "De categorie vetverbranders met 25% korting. Alleen op deze dag.",
    href: collection("fat-burners"),
    cta: "Shop de categorie",
    products: [
      ["Stacker2 Stacker 4", "stacker2-vetverbrander-powder", "stacker2-stacker-4-vetverbrander-powder-01.png?v=1789504857"],
      ["QNT Riptek V2", "qnt-riptek-v2-vetverbrander-120-caps", "qnt-riptek-v2-vetverbrander-120-caps-01.png?v=1789504474"],
      ["Animal Cuts", "animal-cuts-poeder", "animal-cuts-poeder-01-mango.webp?v=1789502596"],
      ["Olimp L-Carnitine 1500", "olimp-sport-nutrition-l-carnitine-1500-mega-caps", "olimp-sport-nutrition-l-carnitine-1500-mega-caps-01.png?v=1789503906"]
    ]
  },
  {
    day: 17,
    short: "Biotech Creatine",
    title: "BiotechUSA Creatine Micronized Zero — 300 gram",
    shop: "Planning: Biotech Creatine 300g",
    discount: "-23%",
    blurb: "De 300-gramvariant van BiotechUSA Creatine Micronized Zero. De geplande korting is 23%.",
    href: product("biotechusa-creatine-micronized-zero") + "?variant=53858943598925",
    image: file("biotechusa-creatine-micronized-zero-01.png?v=1789502882"),
    price: "Huidige winkelprijs 300 gram €24,90"
  },
  {
    day: 18,
    short: "Kousen cadeau",
    title: "Gratis kousen",
    discount: "CADEAU",
    gift: true,
    mock: true,
    condition: "Bij een aankoop vanaf €60",
    blurb: "Gratis kousen bij een aankoop vanaf €60. De kousen staan nog niet in de shop."
  },
  {
    day: 19,
    short: "Shilajit",
    title: "MUSKLE Shilajit+ Gummies",
    shop: "Planning: MUSKLE Shilajit",
    discount: "-35%",
    blurb: "Shilajit van MUSKLE, in de shop als Shilajit+ Gummies. De geplande korting is 35%.",
    href: product("shilajit"),
    image: file("muskle-shilajit-gummies-01.png?v=1789505249"),
    price: "Huidige winkelprijs €49,90"
  },
  {
    day: 20,
    short: "Omega",
    title: "Alle omega",
    discount: "-16%",
    blurb: "Omega-3 uit het assortiment met 16% korting. Alleen op deze dag.",
    href: collection("omega-3"),
    cta: "Shop de categorie",
    products: [
      ["MUSKLE Omega 3 + D3 + K2", "muskle-omega-3-vitamin-d3-k2-120-capsules", "muskle-omega-3-vitamin-d3-k2-120-capsules-01.jpg?v=1789505201"],
      ["Supplement Needs Omega 3", "supplement-needs-omega-3-caps", "supplement-needs-omega-3-90-softgels-01.webp?v=1789505387"],
      ["Olimp Gold Omega 3 + D3 + K2", "olimp-gold-omega-3-d3-k2", "olimp-gold-omega-3-d3-k2-01.png?v=1789503840"],
      ["FFN Omega 3 120 caps", "fast-forward-nutrition-omega-3-120-caps", "fast-forward-nutrition-omega-3-120-caps-01.png?v=1789503395"]
    ]
  },
  {
    day: 21,
    short: "EAA Pump",
    title: "MUSKLE EAA / BCAA Intra Pump Workout",
    shop: "Planning: MUSKLE EAA Pump",
    discount: "-21%",
    blurb: "Intra-workout van MUSKLE met EAA en BCAA, smaak Blueberry / Lemonade, 600 g. De geplande korting is 21%.",
    href: product("muskle-eaa-bcaa-intra-pump-workout"),
    image: file("WhatsAppImage2026-10-07at21.56.52.jpg?v=1791556224"),
    price: "Huidige winkelprijs €39,90"
  },
  {
    day: 22,
    short: "Waterfles cadeau",
    title: "Gratis stalen waterfles 500 ml",
    discount: "CADEAU",
    gift: true,
    mock: true,
    condition: "Bij een aankoop boven €60",
    blurb: "Gratis stalen waterfles van 500 ml, ter waarde van €14,90, bij een aankoop boven €60. Die fles staat nog niet in de shop."
  },
  {
    day: 23,
    short: "Pre-Workout Gummies",
    title: "Muskle Pre-workout Gummy",
    shop: "Planning: MUSKLE Pre-Workout Gummies",
    discount: "-50%",
    blurb: "Pre-workout gummies van MUSKLE, blueberry, 120 stuks. De geplande korting is 50%.",
    href: product("muskle-pre-workout-gummy"),
    image: file("muskle-pre-workout-gummy-01.png?v=1789503625"),
    price: "Huidige winkelprijs €29,90"
  },
  {
    day: 24,
    short: "Vitaminen",
    title: "Categorie vitaminen",
    discount: "-24%",
    blurb: "Vitaminen en mineralen met 24% korting. Alleen op deze dag.",
    href: collection("vitaminen-mineralen"),
    cta: "Shop de categorie",
    products: [
      ["Supplement Needs Vitamine D3 + K2", "supplement-needs-vitamin-d3-and-k2-mk-7-120-tabs", "supplement-needs-vitamin-d3-k2-120-tabs-01.png?v=1789505420"],
      ["Applied Nutrition Multi Vitamin", "applied-nutrition-multi-vitamin", "applied-nutrition-multi-vitamin-01.png?v=1789502735"],
      ["BiotechUSA Vitamin C 1000", "biotechusa-vitamin-c-1000", "biotechusa-vitamin-c-1000-01.png?v=1789502936"],
      ["FFN Multi 800", "fast-forward-nutrition-multi-800-natural-resources-120-caps", "fast-forward-nutrition-multi-800-natural-resources-120-caps-01.jpg?v=1789502459"]
    ]
  },
  {
    day: 25,
    short: "Collageen",
    title: "Categorie collageen",
    discount: "-20%",
    blurb: "Collageen uit het assortiment met 20% korting. Alleen op deze dag.",
    href: collection("collageen"),
    cta: "Shop de categorie",
    products: [
      ["ESN Collagen Peptiden", "collageen-peptiden-300g", "esn-collagen-peptiden-01.png?v=1789503094"],
      ["Organifi Collagen", "organifi-collagen", "organifi-collagen-01.webp?v=1789504266"],
      ["Olimp Collaregen", "olimp-collaregen", "olimp-collaregen-01.png?v=1789501645"],
      ["BiotechUSA Collagen Liquid", "biotechusa-collagen-liquid", "biotechusa-collagen-liquid-01.png?v=1789502882"]
    ]
  },
  {
    day: 26,
    short: "Male Test",
    title: "Muskle Test Male",
    shop: "Planning: MUSKLE Male Test",
    discount: "-40%",
    blurb: "MUSKLE Test Male, 120 capsules. De geplande korting is 40%.",
    href: product("muskle-test-male"),
    image: file("muskle-test-male-01.png?v=1789503625"),
    price: "Huidige winkelprijs €39,90"
  },
  {
    day: 27,
    short: "Alle creatine",
    title: "Alle creatine",
    discount: "-27%",
    tone: "friday",
    blurb: "Black Friday: alle creatine met 27% korting. Dit is de enige deal van vrijdag 27 november.",
    href: collection("creatine"),
    cta: "Shop alle creatine",
    products: [
      ["MUSKLE Creatine Gummies", "creatine-monohydraat-gummies", "muskle-creatine-monohydrate-gummies-01-strawberry.png?v=1789500937"],
      ["Animal Micronized Creatine 500g", "animal-micronized-creatine-500g", "animal-micronized-creatine-500g-01.png?v=1789502505"],
      ["BiotechUSA Creatine Micronized Zero", "biotechusa-creatine-micronized-zero", "biotechusa-creatine-micronized-zero-01.png?v=1789502882"],
      ["FFN Creatine Micronized 300 g", "fast-forward-nutrition-creatine-micronized-3", "fast-forward-nutrition-creatine-micronized-300g-01.png?v=1789503209"]
    ]
  },
  {
    day: 28,
    short: "FFN Hydro",
    title: "Fast Forward Nutrition Hydro Gold",
    shop: "Planning: FFN Hydro",
    discount: "-15%",
    blurb: "Hydro Gold van Fast Forward Nutrition. De geplande korting is 15%.",
    href: product("fast-forward-nutrition-hydro-gold"),
    image: file("fast-forward-nutrition-hydro-gold-01-cappuccino.png?v=1789503255"),
    price: "Huidige winkelprijs vanaf €49,90"
  },
  {
    day: 29,
    short: "Pre-workouts",
    title: "Categorie pre-workouts",
    discount: "-22%",
    blurb: "De categorie pre-workouts met 22% korting. Alleen op deze dag.",
    href: collection("pre-workout"),
    cta: "Shop de categorie",
    products: [
      ["5% Nutrition 51-50", "5-nutrition-51-50", "5-percent-nutrition-51-50-01.png?v=1789501716"],
      ["Trec Boogieman", "trec-boogieman", "trec-boogieman-01.png?v=1789505112"],
      ["Applied Nutrition ABE Pump", "abe-pump-zero-stim-pre-workout", "applied-nutrition-abe-pump-zero-stim-pre-workout-01.png?v=1789502663"],
      ["Trained By JP Pumpage", "trained-by-jp-pumpage", "trained-by-jp-pumpage-01.png?v=1789505050"]
    ]
  },
  {
    day: 30,
    short: "ESN & Scitec Whey",
    title: "ESN Whey en Scitec Whey",
    discount: "-20%",
    tone: "cyber",
    blurb: "Cyber Monday: whey van ESN en Scitec met 20% korting. Er is geen aparte whey-categorie, daarom staan beide merken op deze kaart.",
    ctas: [
      ["Shop ESN Whey", product("esn-designer-whey")],
      ["Shop Scitec Whey", product("scitec-100-whey-professional")]
    ],
    products: [
      ["ESN Designer Whey", "esn-designer-whey", "esn-designer-whey-01.png?v=1789501616"],
      ["ESN Isoclear Whey Isolate", "isoclear-whey-protein-isolate-908g", "esn-isoclear-whey-protein-isolate-01.png?v=1789503117"],
      ["Scitec 100% Whey Professional 2350 g", "scitec-100-whey-professional", "scitec-100-whey-professional-2350g-01.png?v=1789504589"],
      ["Scitec 100% Whey Professional 920 g", "scitec-100-whey-professional-920-gram", "scitec-100-whey-professional-920g-01.png?v=1789504696"]
    ]
  }
];

const byDay = Object.fromEntries(DEALS.map((deal) => [deal.day, deal]));

function brusselsYMD(date) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Brussels",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(date);
  const [y, m, d] = parts.split("-").map(Number);
  return { y, m, d };
}

function weekdayIndex(day) {
  const utc = new Date(Date.UTC(2026, 10, day));
  return utc.getUTCDay();
}

function statusFor(day, sim) {
  const after = sim.y > 2026 || (sim.y === 2026 && sim.m > 11);
  const before = sim.y < 2026 || (sim.y === 2026 && (sim.m < 11));
  if (after) return "past";
  if (before) return "future";
  if (sim.d > day) return "past";
  if (sim.d === day) return "today";
  return "future";
}

function dateLabel(day) {
  return formatLongDate(day);
}

function cdnWidth(url, width) {
  if (!url) return "";
  return url + (url.includes("?") ? "&" : "?") + "width=" + width;
}

function thumb(deal) {
  if (deal.tone === "friday") return cdnWidth(file("muskle-creatine-monohydrate-gummies-01-strawberry.png?v=1789500937"), 640);
  if (deal.image) return cdnWidth(deal.image, 480);
  if (deal.products && deal.products.length) return cdnWidth(file(deal.products[0][2]), 480);
  return "";
}

function mockMini() {
  return `<div class="mock-mini">${t("sample")}<br><span>MUSKLE</span></div>`;
}

function renderCalendar() {
  const root = document.getElementById("calendar");
  const cells = [];
  for (let i = 0; i < 6; i += 1) {
    const date = new Date(Date.UTC(2026, 9, 26 + i));
    cells.push(`<div class="day-out"><span>${date.getUTCDate()}</span><span>${formatMonthShort(9)}</span></div>`);
  }
  DEALS.forEach((deal) => {
    const shot = thumb(deal);
    const friday = deal.tone === "friday";
    const cyber = deal.tone === "cyber";
    const klass = ["day", deal.gift ? "day--gift" : "", friday ? "day--friday" : "", cyber ? "day--cyber" : ""].filter(Boolean).join(" ");
    const dow = friday ? t("monthName") : formatWeekdayShort(deal.day);
    const event = friday
      ? `<span class="day__event">Black Friday</span>`
      : deal.gift
        ? `<span class="day__event">${t("giftWord")}</span>`
        : cyber
          ? `<span class="day__event day__event--cm">Cyber Monday</span>`
          : "";
    const name = friday ? t("allCreatine") : field(deal, "short");
    const alt = friday ? "MUSKLE Creatine" : "";
    cells.push(`
      <button type="button" class="${klass}" data-day="${deal.day}" id="tile-${deal.day}">
        <span class="day__top"><span class="day__num">${deal.day}</span><span class="day__dow">${dow}</span></span>
        <span class="day__shot">${shot ? `<img src="${shot}" alt="${alt}">` : mockMini()}</span>
        ${event}
        <span class="day__name">${name}</span>
        <span class="day__off">${discountLabel(deal)}</span>
      </button>`);
  });
  for (let date = 1; date <= 6; date += 1) {
    cells.push(`<div class="day-out"><span>${date}</span><span>${formatMonthShort(11)}</span></div>`);
  }
  root.innerHTML = cells.join("");
  root.querySelectorAll(".day").forEach((button) => {
    button.addEventListener("click", () => {
      const deal = document.getElementById("deal-" + button.dataset.day);
      deal.scrollIntoView({ behavior: "smooth", block: "start" });
      deal.classList.add("is-focus");
      window.setTimeout(() => deal.classList.remove("is-focus"), 1400);
    });
  });
}

function productTiles(deal, open) {
  return deal.products.map(([name, handle, image]) => {
    const img = `<img src="${cdnWidth(file(image), 480)}" alt="${productName(name)}">`;
    const label = `<span>${productName(name)}</span>`;
    if (!open) return `<div class="mini">${img}${label}</div>`;
    return `<a class="mini" href="${product(handle)}" target="_blank" rel="noopener">${img}${label}</a>`;
  }).join("");
}

function publicBlurb(text) {
  return text
    .replace(/\s*De geplande korting is \d+%(\s+en geldt alleen op deze dag)?\.?/g, "")
    .replace(/\s*De tabel toont \d+% korting\.\s*Dat percentage staat nog ter bevestiging\./g, " Het kortingspercentage staat nog ter bevestiging.")
    .replace(/, zoals in de tabel\. Dat percentage staat nog ter bevestiging\./g, ". Het kortingspercentage staat nog ter bevestiging.")
    .replace(/\s{2,}/g, " ")
    .trim();
}

function renderOffers() {
  const root = document.getElementById("offers");
  root.innerHTML = DEALS.map((deal) => {
    const tone = deal.tone === "friday" ? " offer--friday" : deal.tone === "cyber" ? " offer--cyber" : "";
    let media;
    if (deal.mock) {
      media = `<div class="mock"><strong>${field(deal, "title")}</strong><em>${t("sampleShop")}</em></div>`;
    } else if (deal.products) {
      media = `<div class="mosaic" data-mosaic="${deal.day}"></div>`;
    } else {
      media = `<div class="photo"><img src="${cdnWidth(deal.image, 900)}" alt="${deal.title}"></div>`;
    }
    const ribbon = deal.tone === "friday"
      ? `<span class="ribbon ribbon--bf">Black Friday</span>`
      : deal.tone === "cyber"
        ? `<span class="ribbon ribbon--cm">Cyber Monday</span>`
        : "";
    return `
      <article class="offer${tone}" id="deal-${deal.day}" data-day="${deal.day}">
        <div class="offer__media">
          ${media}
          <span class="badge${deal.gift ? " badge--gift" : ""}">${discountLabel(deal)}</span>
        </div>
        <div class="offer__body">
          <p class="offer__date">${dateLabel(deal.day)}</p>
          <h3>${field(deal, "title")}</h3>
          <p class="offer__discount">${discountLabel(deal)}</p>
          ${ribbon}
          <p class="status" data-status></p>
          <p class="offer__blurb">${publicBlurb(field(deal, "blurb"))}</p>
          ${deal.condition ? `<p class="condition">${conditionText(deal)}</p>` : ""}
          ${deal.price ? `<p class="price">${priceText(deal)}</p>` : ""}
          ${deal.confirm ? `<p class="confirm">${t("confirm")}</p>` : ""}
          <div class="actions" data-actions></div>
        </div>
      </article>`;
  }).join("");
}

function shopButton() {
  return `<button type="button" class="cta-disabled" disabled>${t("previewOnly")}</button>`;
}

function actionsFor(deal, state) {
  if (state !== "today") {
    const label = state === "past" ? t("dealEnded") : t("notYet");
    return `<button type="button" class="cta-disabled" disabled>${label}</button>`;
  }
  if (deal.mock || (!deal.href && !deal.ctas)) {
    return `<button type="button" class="cta-disabled" disabled>${t("noLink")}</button>`;
  }
  if (deal.ctas) {
    return deal.ctas.map(([label, href]) => shopButton(ctaLabel(label), href)).join("");
  }
  return shopButton(ctaLabel(deal.cta || "Shop de deal"), deal.href);
}

const HERO_SLOTS = 6;
const PINNED_SLOT = 3;
const ROTATE_MS = [6800, 7100, 7600, 5400, 8200, 6100];
const START_DELAY = [900, 1600, 2400, 480, 3100, 1900];
let heroSim = null;
let slotDays = [];
let heroTimers = [];
let heroRunning = false;
let heroWatching = false;

function campaignPhase(sim) {
  if (sim.y > 2026 || (sim.y === 2026 && sim.m > 11)) return "after";
  if (sim.y < 2026 || (sim.y === 2026 && sim.m < 11)) return "before";
  return "during";
}

function offerLine(deal) {
  if (deal.gift) return field(deal, "title") + (deal.condition ? " · " + conditionText(deal) : "");
  const amount = deal.discount.startsWith("-") ? deal.discount.slice(1) + " " + t("off") : discountLabel(deal);
  const name = deal.tone === "friday" ? t("allCreatine") : field(deal, "short");
  return name + " — " + amount;
}

function heroCandidates() {
  return DEALS.filter((deal) => thumb(deal));
}

function pickDay(excludeDays, excludeSrc) {
  const pool = heroCandidates().filter((deal) => {
    if (excludeDays.has(deal.day)) return false;
    const src = thumb(deal);
    return !src || !excludeSrc.has(src);
  });
  if (!pool.length) return null;
  return pool[Math.floor(Math.random() * pool.length)].day;
}

function assignHeroSlots(sim) {
  const usedDays = new Set();
  const usedSrc = new Set();
  slotDays = new Array(HERO_SLOTS).fill(null);
  const phase = campaignPhase(sim);
  if (phase === "during") {
    slotDays[PINNED_SLOT] = sim.d;
    usedDays.add(sim.d);
    const src = thumb(byDay[sim.d]);
    if (src) usedSrc.add(src);
  }
  for (let index = 0; index < HERO_SLOTS; index += 1) {
    if (slotDays[index]) continue;
    const day = pickDay(usedDays, usedSrc);
    if (!day) break;
    slotDays[index] = day;
    usedDays.add(day);
    const src = thumb(byDay[day]);
    if (src) usedSrc.add(src);
  }
}

function heroShell(slot) {
  if (slot.querySelector(".hero__off")) return;
  slot.innerHTML = `<span class="hero__bob"><span class="hero__tag"></span><span class="hero__media"><img alt=""></span><span class="hero__off"></span><span class="hero__note"></span><span class="hero__name"></span><span class="hero__when"></span></span>`;
}

function fillSlot(index, animate) {
  const slot = document.querySelector('.hero__float[data-slot="' + index + '"]');
  const deal = byDay[slotDays[index]];
  if (!slot || !deal || !heroSim) return;
  const apply = () => {
    heroShell(slot);
    const state = statusFor(deal.day, heroSim);
    const image = slot.querySelector("img");
    const src = thumb(deal);
    if (src) {
      image.hidden = false;
      if (image.getAttribute("src") !== src) image.src = src;
      image.alt = field(deal, "title");
      slot.classList.remove("hero__float--text");
    } else {
      image.hidden = true;
      image.removeAttribute("src");
      slot.classList.add("hero__float--text");
    }
    const when = formatDayMonth(deal.day, 10);
    slot.querySelector(".hero__name").textContent = field(deal, "short");
    slot.querySelector(".hero__off").textContent = discountLabel(deal);
    slot.querySelector(".hero__note").textContent = deal.gift ? conditionText(deal) : "";
    slot.querySelector(".hero__when").textContent = when;
    const tag = slot.querySelector(".hero__tag");
    tag.textContent = state === "today" ? t("today") : state === "past" ? t("statusPast") : t("statusNext");
    tag.className = "hero__tag hero__tag--" + (state === "today" ? "today" : state === "past" ? "past" : "future");
    slot.classList.toggle("is-featured", state === "today");
    slot.setAttribute("aria-label", tag.textContent + ", " + field(deal, "short") + ", " + when + ", " + discountLabel(deal));
  };
  if (!animate) {
    slot.classList.remove("is-out");
    apply();
    return;
  }
  slot.classList.add("is-out");
  window.setTimeout(() => {
    apply();
    slot.classList.remove("is-out");
  }, 400);
}

function rotateSlot(index) {
  if (!heroSim) return;
  if (campaignPhase(heroSim) === "during" && index === PINNED_SLOT) return;
  const usedDays = new Set(slotDays.filter((day, slotIndex) => slotIndex !== index && day));
  const usedSrc = new Set();
  slotDays.forEach((day, slotIndex) => {
    if (slotIndex === index || !day) return;
    const src = thumb(byDay[day]);
    if (src) usedSrc.add(src);
  });
  const next = pickDay(usedDays, usedSrc);
  if (!next || next === slotDays[index]) return;
  slotDays[index] = next;
  fillSlot(index, true);
}

function stopHeroMotion() {
  heroTimers.forEach((id) => window.clearTimeout(id));
  heroTimers = [];
  heroRunning = false;
}

function motionReduced() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches || new URLSearchParams(location.search).has("still");
}

function startHeroMotion() {
  if (heroRunning || motionReduced() || !heroSim) return;
  const hero = document.querySelector(".hero");
  if (!hero || hero.hidden) return;
  heroRunning = true;
  ROTATE_MS.forEach((ms, index) => {
    const arm = () => {
      heroTimers[index] = window.setTimeout(() => {
        rotateSlot(index);
        if (heroRunning) arm();
      }, ms);
    };
    heroTimers[index] = window.setTimeout(arm, START_DELAY[index]);
  });
}

function watchHero() {
  if (heroWatching) return;
  const hero = document.querySelector(".hero");
  if (!hero || hero.hidden || !("IntersectionObserver" in window)) {
    startHeroMotion();
    return;
  }
  heroWatching = true;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) startHeroMotion();
      else stopHeroMotion();
    });
  }, { threshold: 0.15 });
  observer.observe(hero);
}

function heroActions(deal) {
  if (deal.ctas) return deal.ctas.map(([label, href]) => shopButton(ctaLabel(label), href)).join("");
  if (deal.href) return shopButton(ctaLabel(deal.cta || "Shop de deal"), deal.href);
  return "";
}

function paintHero(sim) {
  const sameMoment = heroSim && heroSim.y === sim.y && heroSim.m === sim.m && heroSim.d === sim.d && slotDays.length === HERO_SLOTS;
  heroSim = sim;
  stopHeroMotion();
  if (!sameMoment) assignHeroSlots(sim);
  for (let index = 0; index < HERO_SLOTS; index += 1) fillSlot(index, false);
  const phase = campaignPhase(sim);
  const kicker = document.getElementById("hero-kicker");
  const title = document.getElementById("hero-deal");
  const actions = document.getElementById("hero-actions");
  const cal = document.getElementById("cal-status");
  if (phase === "before") {
    kicker.textContent = t("heroBefore");
    title.textContent = "";
    actions.innerHTML = "";
    cal.textContent = t("calBefore");
  } else if (phase === "after") {
    kicker.textContent = t("heroAfter");
    title.textContent = "";
    actions.innerHTML = "";
    cal.textContent = t("calAfter");
  } else {
    const deal = byDay[sim.d];
    const line = offerLine(deal);
    kicker.textContent = t("todayOnly");
    title.textContent = line;
    actions.innerHTML = heroActions(deal);
    cal.textContent = t("calDuring") + " — " + line;
  }
  document.querySelectorAll(".hero__float").forEach((slot) => {
    if (slot.dataset.bound) return;
    slot.dataset.bound = "1";
    slot.addEventListener("click", () => {
      const day = slotDays[Number(slot.dataset.slot)];
      const card = document.getElementById("deal-" + day);
      if (!card) return;
      card.scrollIntoView({ behavior: "smooth", block: "start" });
      card.classList.add("is-focus");
      window.setTimeout(() => card.classList.remove("is-focus"), 1400);
    });
  });
  watchHero();
  const hero = document.querySelector(".hero");
  if (!hero || hero.hidden) return;
  const rect = hero.getBoundingClientRect();
  if (rect.bottom > 80 && rect.top < window.innerHeight) startHeroMotion();
}

function paint(sim) {
  DEALS.forEach((deal) => {
    const state = statusFor(deal.day, sim);
    const tile = document.getElementById("tile-" + deal.day);
    const card = document.getElementById("deal-" + deal.day);
    tile.classList.remove("is-past", "is-today", "is-future");
    card.classList.remove("is-today", "is-past");
    tile.classList.add(state === "past" ? "is-past" : state === "today" ? "is-today" : "is-future");
    if (state === "today") card.classList.add("is-today");
    if (state === "past") card.classList.add("is-past");

    tile.querySelectorAll(".day__x, .day__lock").forEach((node) => node.remove());
    card.querySelectorAll(".photo__x, .photo__lock").forEach((node) => node.remove());
    if (state === "past") {
      tile.querySelector(".day__shot").insertAdjacentHTML("beforeend", `<span class="day__x">${X_SVG}</span>`);
      card.querySelector(".offer__media").insertAdjacentHTML("beforeend", `<span class="photo__x">${X_SVG}</span>`);
    }
    if (state === "future") {
      tile.querySelector(".day__top").insertAdjacentHTML("beforeend", `<span class="day__lock">${LOCK_SVG}</span>`);
      card.querySelector(".offer__media").insertAdjacentHTML("beforeend", `<span class="photo__lock">${LOCK_SVG}</span>`);
    }

    const status = card.querySelector("[data-status]");
    status.className = "status " + (state === "today" ? "status--today" : state === "past" ? "status--past" : "status--next");
    status.textContent = state === "today" ? t("statusToday") : state === "past" ? t("statusPast") : t("statusNext");
    card.querySelector("[data-actions]").innerHTML = actionsFor(deal, state);

    const mosaic = card.querySelector("[data-mosaic]");
    if (mosaic) mosaic.innerHTML = productTiles(deal, state === "today");
  });

  const status = document.getElementById("hero-status");
  const viewedFull = new Intl.DateTimeFormat(localeTag(), {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC"
  }).format(new Date(Date.UTC(sim.y, sim.m - 1, sim.d, 12)));
  if (sim.y === 2026 && sim.m === 11) {
    status.textContent = t("heroDuring").replace("{date}", viewedFull).replace("{day}", String(sim.d));
  } else if (sim.y > 2026 || (sim.y === 2026 && sim.m > 11)) {
    status.textContent = t("heroEnded").replace("{date}", viewedFull);
  } else {
    status.textContent = t("heroLocked").replace("{date}", viewedFull);
  }
  paintHero(sim);
}

function applyStaticCopy() {
  document.documentElement.lang = lang === "en" ? "en" : "nl";
  document.title = "MUSKLE Black November 2026";
  document.querySelectorAll("[data-i18n]").forEach((node) => {
    node.textContent = t(node.dataset.i18n);
  });
  document.querySelectorAll("[data-i18n-html]").forEach((node) => {
    node.innerHTML = t(node.dataset.i18nHtml);
  });
  const poster = document.querySelector(".hero__art");
  if (poster) poster.alt = t("posterAlt");
  const note = document.getElementById("poster-note");
  if (note) {
    note.textContent = t("posterNote");
    note.hidden = lang !== "en";
  }
  const weekdays = lang === "en"
    ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    : ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
  document.querySelectorAll(".weekdays span").forEach((node, index) => {
    node.textContent = weekdays[index];
  });
  document.querySelectorAll("[data-sim]").forEach((button) => {
    if (button.dataset.sim === "today") {
      button.textContent = t("today");
      return;
    }
    const parts = button.dataset.sim.split("-").map(Number);
    button.textContent = formatDayMonth(parts[2], parts[1] - 1);
  });
  const switcher = document.querySelector(".lang-switch");
  if (switcher) switcher.setAttribute("aria-label", t("langLabel"));
  const simGroup = document.querySelector(".preview-tools__buttons");
  if (simGroup) simGroup.setAttribute("aria-label", t("simGroup"));
  document.querySelectorAll("[data-lang]").forEach((button) => {
    button.setAttribute("aria-pressed", String(button.dataset.lang === lang));
  });
  const calendar = document.getElementById("calendar");
  if (calendar) calendar.setAttribute("aria-label", t("calTitle"));
  const shareUrl = location.href;
  const shareImage = poster && poster.currentSrc ? poster.currentSrc : (poster && poster.src ? poster.src : "");
  setMeta("og:title", "MUSKLE Black November 2026");
  setMeta("og:description", lang === "en" ? "30 Days. 30 Deals." : "30 dagen. 30 deals.");
  setMeta("og:image", shareImage);
  setMeta("og:url", shareUrl);
  setMeta("og:type", "website");
}

function setMeta(property, content) {
  let node = document.querySelector(`meta[property="${property}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute("property", property);
    document.head.appendChild(node);
  }
  node.setAttribute("content", content);
}

let activeSim = "today";

function refreshLanguage() {
  const y = window.scrollY;
  applyStaticCopy();
  renderCalendar();
  renderOffers();
  paint(parseSim(activeSim));
  window.scrollTo(0, y);
}

function watchReturn() {
  const btn = document.getElementById("to-cal");
  const cal = document.getElementById("kalender");
  if (!btn || !cal) return;
  const update = () => {
    if (new URLSearchParams(location.search).get("show") === "return") {
      btn.hidden = false;
      return;
    }
    if (cal.hidden) {
      btn.hidden = true;
      return;
    }
    btn.hidden = cal.getBoundingClientRect().bottom >= 72;
  };
  if (!btn.dataset.bound) {
    btn.dataset.bound = "1";
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
  }
  update();
  window.requestAnimationFrame(update);
}

function parseSim(value) {
  if (value === "today") return brusselsYMD(new Date());
  const [y, m, d] = value.split("-").map(Number);
  return { y, m, d };
}

function initPreview() {
  const bar = document.getElementById("preview-tools");
  const audit = document.getElementById("audit");
  const switcher = document.querySelector(".lang-switch");
  if (switcher) {
    switcher.addEventListener("click", (event) => {
      const button = event.target.closest("[data-lang]");
      if (!button || button.dataset.lang === lang) return;
      lang = button.dataset.lang;
      persistLang();
      refreshLanguage();
    });
  }
  if (PUBLIC_BUILD) {
    bar.remove();
    if (audit) audit.remove();
    paint(brusselsYMD(new Date()));
    watchReturn();
    return;
  }
  bar.hidden = false;
  let current = "today";
  const apply = (value) => {
    current = value;
    activeSim = value;
    bar.querySelectorAll("button").forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.sim === value));
    });
    paint(parseSim(value));
  };
  bar.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-sim]");
    if (!button) return;
    apply(button.dataset.sim);
  });
  const params = new URLSearchParams(location.search);
  const requested = params.get("sim");
  if (requested && (requested === "today" || /^\d{4}-\d{2}-\d{2}$/.test(requested))) current = requested;
  apply(current);
  const shot = params.get("shot");
  if (shot === "hero") {
    document.querySelector(".calendar-wrap").hidden = true;
    document.querySelector(".offers-wrap").hidden = true;
    const auditNode = document.querySelector(".audit");
    if (auditNode) auditNode.hidden = true;
    document.querySelector(".footer").hidden = true;
  }
  if (shot === "calendar") {
    document.querySelector(".hero").hidden = true;
    document.querySelector(".offers-wrap").hidden = true;
    const auditNode = document.querySelector(".audit");
    if (auditNode) auditNode.hidden = true;
    document.querySelector(".footer").hidden = true;
  }
  if (shot === "deals-5-6") {
    document.querySelector(".hero").hidden = true;
    document.querySelector(".calendar-wrap").hidden = true;
    document.querySelector(".section-head--light").hidden = true;
    document.querySelectorAll(".offer").forEach((card) => {
      card.hidden = card.id !== "deal-5" && card.id !== "deal-6";
    });
    const auditNode = document.querySelector(".audit");
    if (auditNode) auditNode.hidden = true;
    document.querySelector(".footer").hidden = true;
  }
  if (shot && /^deal-\d+$/.test(shot)) {
    document.querySelector(".hero").hidden = true;
    document.querySelector(".calendar-wrap").hidden = true;
    document.querySelector(".section-head--light").hidden = true;
    document.querySelectorAll(".offer").forEach((card) => {
      card.hidden = card.id !== shot;
    });
    const auditNode = document.querySelector(".audit");
    if (auditNode) auditNode.hidden = true;
    document.querySelector(".footer").hidden = true;
  }
  const view = params.get("view");
  if (view && !shot) {
    const target = document.getElementById(view);
    if (target) target.scrollIntoView({ block: "start" });
  }
  if (params.get("show") === "return") {
    document.querySelector(".hero").hidden = true;
    document.querySelector(".calendar-wrap").hidden = true;
  }
  if (params.get("scroll") === "deals") {
    const deals = document.getElementById("deals");
    if (deals) deals.scrollIntoView({ block: "start" });
  }
  watchReturn();
}

lang = readInitialLang();
persistLang();
applyStaticCopy();
renderCalendar();
renderOffers();
initPreview();
